module.exports = __webpack_public_path__ + "static/media/Branding.fcc5ee8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Teafloor/Branding.jpg
// module id = 364
// module chunks = 0